import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { COLORS, FONTS } from '@stelecom/ui-react/assets/js/constants';
import { connect } from 'react-redux';
import { dataLayerPush } from '@stelecom/ui-react/components/helpers';
import FormContainer from '@stelecom/ui-react/components/layouts/formContainer';
import StyledButton from '@stelecom/ui-react/components/buttons/styledButton';
import PopupResult from '@stelecom/ui-react/components/popups/popupResult';
import EnterContractNumber from '../../components/RestorePassword/enterContractNumber';
import EnterPhoneOrEmail from '../../components/RestorePassword/enterPhoneOrEmail';
import ChooseAddress from '../../components/RestorePassword/chooseAddress';
import ChooseChannel from '../../components/RestorePassword/chooseChannel';
import { getContactList, sendNewPassword } from '../../api/auth';
import { citiesListForHeader } from '../../store/selectors/city';
import { openCitySelect } from '~/src/store/actions/citySelect';
import { CATEGORIES, EVENTS } from '~/src/constants/analytics';
import PopupNoWork from '~/src/components/Popups/NoWorkExcuses/popupExcuses';

const Header = styled.h1`
  ${FONTS.H2};
  width: 70%;
  margin-bottom: 20px;
  color: ${COLORS.blueDark};
  font-weight: 800;
`;

const ContainerRecovery = styled.div`
  box-shadow: 0 8px 16px rgba(184, 203, 222, 0.6);
  border-radius: 8px;
  padding: 50px 85px;

  @media (max-width: 768px) {
    padding: 20px 35px;
  }
`;

const Text = styled.p`
  margin-bottom: 20px;
  width: 100%;
  color: ${COLORS.grey};
  ${FONTS.S};
  @media (max-width: 640px) {
    margin-bottom: 10px;
  }
`;

const Link = styled.a`
  cursor: pointer;
  color: ${COLORS.blueDark};
  border-bottom: 1px solid ${COLORS.BARDO_LINE};
  transition: color 0.2s linear, border-color 0.2s linear;
  margin: 25px auto 0;
  &:hover {
    color: ${COLORS.PINK_BRIGHT};
    border-color: ${COLORS.PINK_BRIGHT};
  }
`;

const ButtonContainer = styled.div`
  width: 100%;
  margin-bottom: 14px;
`;

const ContainerForNumbers = styled(ButtonContainer)`
  display: flex;
`;

const NumberTextContainer = styled.div`
    max-width: 340px;
    display: inline-block;
    color: ${COLORS.grey};
`;

const Number = styled.a`
  color: ${COLORS.PINK_BRIGHT};
  text-decoration: underline;
`;

const Address = styled.p`
  ${FONTS.S};
`;

const DEFAULT_ERROR_MESSAGE =
  'Пожалуйста, попробуйте позднее. При повторении ошибки обратитесь в техническую поддержку';
const DEFAULT_ERROR_TITLE = 'Произошла ошибка';
const GA_CONTRACT_ACTION = 'Account id';
const GA_SMS_ACTION = 'tel';
const GA_EMAIL_ACTION = 'e-mail';
const REDIRECT_LINK =
  '/user/login?referrer=/user/change/password&forceRedirect=true';
const CONTACT_TYPE_PHONE = 2;
const CONTACT_TYPE_EMAIL = 1;

class RestorePassword extends Component {
  state = {
    step: 0,
    showErrorPopup: false,
    history: [],
    gaAction: '',
    contactType: null,
    isOpen: false,
  };

  sendEvent = (action, label) => {
    dataLayerPush({
      event: EVENTS.UAevent,
      category: CATEGORIES.changePassword,
      action: action,
      label: label,
    });
  };

    handleClose = () => {
        this.setState({ isOpen: !this.state.isOpen });
    };

  togglePopup = (
    isOpen,
    error = DEFAULT_ERROR_MESSAGE,
    errorTitle = DEFAULT_ERROR_TITLE
  ) => {
    const { gaAction } = this.state;
    if (isOpen) {
      this.sendEvent(gaAction, 'error');
    }
    this.setState({
      showErrorPopup: isOpen,
      errorMessage: error,
      errorTitle: errorTitle,
    });
  };

  goToStep = (nextStep) => {
    this.setState((state) => ({
      history: state.history.concat(state.step),
      step: nextStep,
    }));
  };

  goBack = () => {
    var prevStep = this.state.history.pop();
    this.setState({
      step: prevStep,
    });
  };

  parsePhonesAndMails = (contract, contactType) =>
    contract.contacts
      .filter((contact) => contact.contactType === contactType)
      .map((contact) => ({
        id: contact.contactId,
        value: contact.contactId,
        label: contact.row,
        agreementId: contract.agreementId,
        ...contact,
      }));

  parseAddress = (contract) =>
    contract.agreements.map((contact) => ({
      id: contact.contactId,
      value: contact.contactId,
      hiddenAgreement: '********' + String(contact.agreementNumber).slice(8),
      label: (
        <Address>
          {'********' + String(contact.agreementNumber).slice(8)}
          <br />
          {/* {contact.value}*/}
        </Address>
      ),
      agreementNumber: contact.agreementNumber,
      ...contact,
    }));

  goToAddressChoosing = (contact) => {
    const { billingDomain, city } = this.props;
    getContactList(billingDomain || city.domain, contact).then(
      (response) => {
        if (response.isError) {
          const error = this.getError(response);
          this.togglePopup(true, error.message, error.title);
        } else {
          const { gaAction } = this.state;
          const contracts = this.parseAddress(response);
          this.sendEvent(gaAction, 'Number enter');
          this.setState({
            contracts: contracts,
          });
          this.goToStep(3);
        }
      },
      () => this.togglePopup(true)
    );
  };

  goToChannelChoosing = (contact, label) => {
    const { gaAction } = this.state;
    const { billingDomain, city } = this.props;
    getContactList(billingDomain || city.domain, contact).then(
      (response) => {
        if (response.isError) {
          const error = this.getError(response);
          this.togglePopup(true, error.message, error.title);
        } else {
            const newResponse = {
                'contacts': [
                ],
                'code': '',
                'message': ''
            };
            response.emails?.map((item)=> {
                newResponse.contacts.push(
               {
                   'contactId': item.contactId,
                   'agreementId': item.agreementId,
                   'contactType': item.sendType,
                   'row': item.value,
                   'agreementNumber':item.agreementNumber,
                   'rowEnc': null,
                   'address': ''
               }
               );
           });
            response.phones?.map((item)=> {
                newResponse.contacts.push(
                    {
                        'contactId': item.contactId,
                        'agreementId': item.agreementId,
                        'contactType': item.sendType,
                        'row': item.value,
                        'agreementNumber':item.agreementNumber,
                        'rowEnc': null,
                        'address': ''
                    }
                );
            });


          const phones = this.parsePhonesAndMails(newResponse, CONTACT_TYPE_PHONE);
          const emails = this.parsePhonesAndMails(newResponse, CONTACT_TYPE_EMAIL);
          if (phones.length == 0 && emails.length == 0) {
            this.togglePopup(true);
          } else {
            this.setState({
              options: {
                phones: phones,
                emails: emails,
              },
            });
            this.sendEvent(gaAction, label);
            this.goToStep(4);
          }
        }
      },
      () => this.togglePopup(true)
    );
  };

  getError = (response) => {
    let message =
      response.errorMessage.length !== 0
        ? response.errorMessage
        : DEFAULT_ERROR_MESSAGE;
    let title = DEFAULT_ERROR_TITLE;
    switch (response.isError) {
      case true:
        switch (this.state.step) {
          case 1:
            title = 'Неверно указан номер договора';
            message = (
              <Fragment>
                <Text>
                  1. Проверьте правильность ввода номера договора, возможно
                  допущена ошибка.
                </Text>
                <Text>
                    2. Если вы не помните номер договора, обратитесь в информационный центр по номеру +7 (495) 145 8 555.
                </Text>
                <Text>
                  3. Попробуйте восстановить пароль через e-mail или телефон.
                </Text>
              </Fragment>
            );
            break;
          case 2:
            switch (this.state.contactType) {
              case CONTACT_TYPE_PHONE:
                title = 'По указанному номеру телефона договор не найден';
                message = (
                  <Fragment>
                    <Text>
                      1. Данный телефон может быть не связан с вашим договором.
                    </Text>
                    <Text>
                      2. Проверьте правильность ввода номера телефона, возможно
                      допущена ошибка.
                    </Text>
                    <Text>
                      3. Проверьте, верно ли указан{' '}
                      <Link onClick={this.switchShowCitySelect}>город</Link>.
                    </Text>
                    <Text>4. Попробуйте восстановить другим способом.</Text>
                  </Fragment>
                );
                break;
              case CONTACT_TYPE_EMAIL:
                title = 'По указанному email договор не найден';
                message = (
                  <Fragment>
                    <Text>
                      1. Данный e-mail может быть не связан с вашим договором.
                    </Text>
                    <Text>
                      2. Проверьте правильность ввода e-mail, возможно допущена
                      ошибка.
                    </Text>
                    <Text>
                      3. Проверьте, верно ли указан{' '}
                      <Link onClick={this.switchShowCitySelect}>город</Link>.
                    </Text>
                    <Text>4. Попробуйте восстановить другим способом.</Text>
                  </Fragment>
                );
                break;
            }
            break;
        }
        break;
      case 'CONTACTS_NOT_FOUND':
        message = <span> </span>;
        break;
      case 'SMS_ALREADY_SENDED':
        title = 'SMS уже направлена на данный номер';
        message = <span></span>;
        break;
    }

    return { message, title };
  };

  restorePassword = (channel, contact) => {
    const label = channel == 'email' ? 'e-mail restore' : 'sms restore';
    const { gaAction } = this.state;
    const { billingDomain, city } = this.props;
    this.sendEvent(gaAction, label);
    sendNewPassword(billingDomain || city.domain, contact).then(
      (response) => {
        if (response.isError) {
          const error = this.getError(response);
          this.togglePopup(true, error.message, error.title);
        } else {
          this.sendEvent(gaAction, 'success');
          this.setState({
            selectedChannel: channel,
            selectedContact: contact,
          });
          this.goToStep(5);
        }
      },
      () => this.togglePopup(true)
    );
  };

  goContractPath = () => {
    this.setState({
      gaAction: GA_CONTRACT_ACTION,
    });
    this.sendEvent(GA_CONTRACT_ACTION, 'click');
    this.goToStep(1);
  };

  goSmsPath = () => {
    this.setState({
      contactType: CONTACT_TYPE_PHONE,
      gaAction: GA_SMS_ACTION,
    });
    this.sendEvent(GA_SMS_ACTION, 'tel enter');
    this.goSmsEmailPath();
  };

  goEmailPath = () => {
    this.setState({
      contactType: CONTACT_TYPE_EMAIL,
      gaAction: GA_EMAIL_ACTION,
    });
    this.sendEvent(GA_EMAIL_ACTION, 'e-mail enter');
    this.goSmsEmailPath();
  };

  goSmsEmailPath = () => {
    this.goToStep(2);
  };

  switchShowCitySelect = () => {
    this.setState({
      showErrorPopup: false,
    });
    this.props.openCitySelect();
  };

  forgetAllHandler = () => {
    dataLayerPush({
      event: EVENTS.UAevent,
      category: 'restorePassword',
      action: 'click to button',
      label: 'forget_all',
    });
  };

  render() {
    const {
      step,
      contracts,
      options,
      selectedChannel,
      selectedContact = {},
      showErrorPopup,
      errorMessage,
      errorTitle,
    } = this.state;
    const RestoreContent = () => {
      switch (step) {
        case 0:
          return (
            <Fragment>
              <Text>
                Укажите данные, которые вы использовали при заключении договора
              </Text>
              <ButtonContainer>
                <StyledButton
                  text='Я помню номер договора'
                  onClick={this.goContractPath}
                />
              </ButtonContainer>
              <ButtonContainer>
                <StyledButton text='Я помню телефон' onClick={this.goSmsPath} />
              </ButtonContainer>
              <ButtonContainer>
                <StyledButton
                  text='Я помню e-mail'
                  onClick={this.goEmailPath}
                />
              </ButtonContainer>
              <ContainerForNumbers>
                {/* <StyledButton
                  text='Не помню данные – открыть чат'
                  type='secondary'
                  onClick={this.forgetAllHandler}
                />*/}
                  <NumberTextContainer>
                      Если вы не помните данные — позвоните нам
                      по номеру <Number href={'tel:+74951458555'}>+7 (495) 145 85 55</Number>, <Number href={'tel:+74958033777'}>+7 (495) 803 37 77</Number>
                  </NumberTextContainer>
              </ContainerForNumbers>
              <Link href='/user/login'>Назад к авторизации</Link>
              <PopupNoWork isOpen={this.state.isOpen} onClose={this.handleClose}/>
            </Fragment>
          );
        case 1:
          return (
            <Fragment>
              <Text>Введите номер договора:</Text>
              <EnterContractNumber
                next={(contact) =>
                  this.goToChannelChoosing(contact, 'Number enter')
                }
              ></EnterContractNumber>
              <Link onClick={this.goBack}>Назад</Link>
            </Fragment>
          );
        case 2:
          return (
            <Fragment>
              <Text>
                {this.state.contactType === CONTACT_TYPE_PHONE
                  ? 'Введите номер телефона без «8»:'
                  : 'Введите E-mail:'}
              </Text>
              <EnterPhoneOrEmail
                next={this.goToAddressChoosing}
                contactType={this.state.contactType}
              ></EnterPhoneOrEmail>
              <Link onClick={this.goBack}>Назад</Link>
            </Fragment>
          );
        case 3:
          return (
            <Fragment>
              <Text>Выберите номер договора:</Text>
              <ChooseAddress
                next={(contact) =>
                  this.goToChannelChoosing(contact, 'Account id')
                }
                options={contracts}
              ></ChooseAddress>
              <Link onClick={this.goBack}>Назад</Link>
            </Fragment>
          );
        case 4:
          return (
            <Fragment>
              <ChooseChannel
                next={this.restorePassword}
                options={options}
              ></ChooseChannel>
              <Link onClick={this.goBack}>Назад</Link>
            </Fragment>
          );
        case 5:
          var message =
            selectedChannel === 'email'
              ? selectedContact.label + ' отправлено письмо'
              : 'номер ' + selectedContact.label + ' отправлено SMS';
          return (
            <Fragment>
              <Text>На {message} с паролем</Text>
              <StyledButton
                text='Вернуться к авторизации'
                href={REDIRECT_LINK}
              />
            </Fragment>
          );
        default:
          return null;
      }
    };
    const errorPopup = (
      <PopupResult
        type='error'
        isOpen={showErrorPopup}
        onClose={() => this.togglePopup(false)}
        title={errorTitle}
        text={errorMessage}
      />
    );
    return (
      <FormContainer maxWidth='730px'>
        <ContainerRecovery>
          <Header>
            {step === 5 ? 'Пароль восстановлен' : 'Восстановление пароля'}
          </Header>
          <RestoreContent />
          {step > 0 ? errorPopup : null}
        </ContainerRecovery>
      </FormContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  cities: citiesListForHeader(state),
  billingDomain: state.auth.billingDomain,
});

const mapDispatchToProps = (dispatch) => ({
  openCitySelect: () => dispatch(openCitySelect()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RestorePassword);
